(ns teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-assign-modal
  (:require [goog.object :as g]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.save :refer [save]]
            [teamoesterreich.setup :refer [USER_DOCUMENT_TYPES]]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.element.backend-file :as backend-file]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.log :as log]))


(defn date-ger [date]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count date) 12)
    (str (subs date 6 8) "." (subs date 4 6) "." (subs date 0 4)
         )
    ""
    ))

(defn change-type [user-uuid document type cb-fn]
  (log/debug "change-type " user-uuid document type)
  (d-user/>user-edit-document-field (:userDocument-uuid document) {:userDocument-type (str type)} cb-fn)
  (when (= type "profilePicture") (d-user/>user-edit-field user-uuid
                                                           {:user-portraitFileHash (:userDocument-path document)
                                                            :user-fsPortraitPath   ""
                                                            :invalidatePortrait    true
                                                            }
                                                           cb-fn))
  )


(defn event-result
  [^js/Event e]
  (-> e (g/get "target") (g/get "result")))


(defn file-upload [!actual-user files userDokument-type]
  (when-let [file (.item files 0)]
    (let [fr (js/FileReader.)]
      (set! (.-onload fr)
            (fn [event]
              (log/out "read file" event (event-result event))
              (d-user/>userDocument-upload (:user-uuid @!actual-user)
                                           userDokument-type
                                           {:buffer       (event-result event)
                                            :file-name    (g/get file "name")
                                            :content-type (g/get file "type")
                                            :on-finished  (fn [url] (log/out "got back URL" url))})
              ))

      (.readAsArrayBuffer fr file))))


(defn document-tile [document !selected]
  (let [{:keys [userDocument-type userDocument-fileName userDocument-path userDocument-since userDocument-uuid]} document]
    [mui/grid {:item    true
               :style   {:width            "150px" :height "180px" :overflow "hidden"
                         :border           (if (= userDocument-uuid @!selected) "2px solid red" "2px solid white")
                         :background-color (cond
                                             (:userDocument-rejected document) "#525252"
                                             (or (:userDocument-isIdentity document)
                                                 (:userDocument-isSelfExplain document)
                                                 (:userDocument-isTraining document))
                                             "inherit")
                         }
               :onClick (fn [_] (reset! !selected userDocument-uuid))
               }

     [backend-file/img {:hash     userDocument-path
                        :preview? true
                        :style    {:height "100px" :width "145px" :objectFit "contain"} :alt "Ansicht"}]

     [:div {:style {:fontSize "11px" :overflow "hidden" :padding "0 5px 0 5px"}}
      [:span {:style {:color "blue"}} (or (get USER_DOCUMENT_TYPES userDocument-type) (str "? " userDocument-type))]
      [:br]
      [:span {} (or userDocument-fileName userDocument-path)]
      [:br]
      [:span {} (when userDocument-since (date-ger userDocument-since))]
      [:br]
      (when (:userDocument-rejected document) [:span {:style {:color "red"}} "!! Abgelehnt !! "])
      (when (:userDocument-isIdentity document) [:span {:style {:color "green"}} "Ist Identität Dokument "])
      (when (:userDocument-isTraining document) [:span {:style {:color "green"}} "Ist Qualifikation Dokument "])
      (when (:userDocument-isSelfExplain document) [:span {:style {:color "green"}} "Ist Selbsterklärung Dokument "])
      ]]))


(defn modal [!actual-user !list-st & [on-select-cb]]
  (let [!show-doc-assign-modal (r/cursor !list-st [:!show-doc-assign-modal])
        !list-selected-document (r/cursor !list-st [:selected-document])

        !st (r/atom {:selected @!list-selected-document :pre-selected @!list-selected-document})
        !selected (r/cursor !st [:selected])
        user-tomId (:user-tomId @!actual-user)
        !show-identity-modal (r/cursor !list-st [:show-identity-modal])
        !show-selfdeclaration-modal (r/cursor !list-st [:show-selfdeclaration-modal])
        !show-training-modal (r/cursor !list-st [:show-training-modal])
        ]
    (fn []
      (let [{tomId :showTomId type :type} @!show-doc-assign-modal]
        (println "document-assign-modal/modal " @!show-doc-assign-modal " user" user-tomId " doc " @!list-selected-document)
        [mui/modal
         {:className        "doc-assign-modal"

          :aria-labelledby  "simple-modal-title"
          :aria-describedby "simple-modal-description"
          :style            {:display        "flex"
                             :marginRight    "auto"
                             :marginLeft     "auto"
                             :alignItems     "center"
                             :justifyContent "center"}
          :open             (if tomId true false)

          }

         [:div
          {
           :class "modal"
           :style {:width 600}}
          [:h2 "Anderes Dokument wählen für " (case type
                                                :training "Qualifikation"
                                                :selfExplain "Selbsterklärung"
                                                :identity "Identität"
                                                ""
                                                )]
          [mui/grid {:container true}
           [mui/grid {:item    true
                      :style   {:width  "150px" :height "180px" :overflow "hidden"
                                :border (if (nil? @!selected) "2px solid red" "2px solid white")}
                      :onClick (fn [_] (reset! !selected nil))
                      } "kein Dokument"]

           (doall (for [doc (reverse (sort-by :userDocument-since (filter :userDocument-active (:user-userDocument @!actual-user))))]
                    ^{:key (str "userDocument-" (:userDocument-uuid doc))}
                    [document-tile doc !selected]))

           ]

          [:br]
          [:br]
          [:br]
          [mui/button
           {:variant   "contained"
            :startIcon (r/as-element [keyboard-arrow-left])
            :style     {:marginRight 50}
            :onClick   (fn []
                         (reset! !show-doc-assign-modal false)
                         (case type
                           :training (reset! !show-training-modal user-tomId)
                           :selfExplain (reset! !show-selfdeclaration-modal user-tomId)
                           :identity (reset! !show-identity-modal user-tomId)
                           ""
                           )
                         )
            }
           "Abbrechen"]
          [mui/button
           {:color     "primary"
            ;:disabled  (= @!new-type (or userDocument-type ""))
            :style     {:float "right"}
            :variant   "contained"
            :startIcon (r/as-element [save])
            :onClick   (fn []
                         (reset! !show-doc-assign-modal false)
                         (if on-select-cb
                           (on-select-cb @!selected)
                           (reset! !list-selected-document @!selected))
                         (case type
                           :training (reset! !show-training-modal user-tomId)
                           :selfExplain (reset! !show-selfdeclaration-modal user-tomId)
                           :identity (reset! !show-identity-modal user-tomId)
                           ""
                           )
                         )
            }
           "OK"]]
         ]
        ))))

(defn get-user-details [!actual-user tomId]
  (d-user/get-user-all tomId (fn [data] (reset! !actual-user data)))
  )

(defn modal-by-tomId [!list-st]
  (let [!actual-user (r/atom nil)
        !show-doc-assign-modal (r/cursor !list-st [:!show-doc-assign-modal])]
    (fn []
      (let [user @!actual-user
            {tomId :showTomId} @!show-doc-assign-modal]
        (log/debug "document change modal-by-tomId " @!show-doc-assign-modal)

        (when (and (pos? tomId) (not= tomId (:reqTomId user))) (get-user-details !actual-user tomId))

        (if (or (not (pos? tomId))
                (not= tomId (:reqTomId user))
                (:error user))
          ;no data
          [mui/modal
           {:className        "doc-assign-load-modal"
            :aria-labelledby  "simple-modal-title"
            :aria-describedby "simple-modal-description"
            :style            {:display        "flex"
                               :marginRight    "auto"
                               :marginLeft     "auto"
                               :alignItems     "center"
                               :justifyContent "center"}
            :open             (pos? tomId)
            :onClose          (fn []
                                (reset! !actual-user nil)
                                (reset! !show-doc-assign-modal nil))
            }
           [:div
            {:class "modal"
             :style {:width 400}}
            [:h4 (str "Qualifikationsnachweis prüfen ")]
            [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
            [mui/typography "Lade den Datensatz ... "]
            [mui/typography {:color "primary"} (:error user)]
            [:br]
            [mui/button
             {:color    "primary"
              :variant  "contained"
              :on-click (fn []
                          (reset! !actual-user nil)
                          (reset! !show-doc-assign-modal nil))
              }
             "Schließen"]
            ]]
          ;has data
          (modal !actual-user !list-st)

          )))))